var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.329262 15.6474L0.332313 15.7952C0.332313 16.1381 0.561628 16.439 0.891539 16.5297C0.959359 16.548 1.02714 16.5571 1.09422 16.5571C1.35783 16.5571 1.60925 16.4192 1.74868 16.1853C4.76657 11.1126 8.76505 10.9686 10.2371 11.1118V15.0334C10.2371 15.3412 10.4222 15.62 10.7072 15.7374C10.9929 15.8562 11.3197 15.7899 11.5376 15.572L18.3948 8.71491C18.6926 8.41692 18.6926 7.93537 18.3948 7.63749L11.5376 0.780351C11.3197 0.563201 10.9929 0.496906 10.7072 0.615024C10.4222 0.73236 10.2371 1.01123 10.2371 1.31904V4.36971C5.85307 4.54951 2.02833 7.50952 0.803183 11.751C0.273602 13.5878 0.313939 15.0804 0.329202 15.6452L0.329262 15.6474ZM1.95605 12.084C1.71284 12.9278 1.60283 13.6905 1.55531 14.3056C2.99478 12.3524 4.60057 11.216 6.10993 10.5853C7.90244 9.83635 9.48054 9.83252 10.3533 9.91746L11.4371 10.0229V13.9755L17.2364 8.1762L11.4371 2.37685V5.5215L10.2862 5.5687C6.41263 5.72757 3.03652 8.34433 1.95605 12.084Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageForward);
export default __webpack_public_path__ + "static/media/message_forward.277a4ef73f5b32ab44875fbd6e7f2f0d.svg";
export { ForwardRef as ReactComponent };